<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAppState } from '../stores/AppState'
import { getCompanyName, getLogo } from '../utils/branding'

const appState = useAppState()
const overlay = ref(false)
const rail = ref(true)
const appName = ref('')
const logoUrl = ref('')
const router = useRouter()

function closeOverlayOnRouteChange() {
  overlay.value = false // Close the overlay
  rail.value = true // Reset the rail state if needed
}

onMounted(async () => {
  appName.value = await getCompanyName()
  logoUrl.value = await getLogo()

  // Close the overlay when the route changes
  router.beforeEach(() => {
    closeOverlayOnRouteChange()
    return true // Allow the navigation
  })
})
</script>

<template>
  <nav>
    <v-layout class="z-index-999" id="secMainNav">
      <v-navigation-drawer :rail="rail" permanent id="secMainNavDrawer">
        <v-list density="compact">
          <v-list-item
            class="d-flex justify-center"
            @click="((rail = !rail), (overlay = !overlay))"
            id="secMainNavDrawerChevronListItem"
          >
            <v-icon
              :icon="!rail ? 'mdi-chevron-left' : 'mdi-chevron-right'"
              id="secMainNavDrawerChevronListItemIcon"
            >
            </v-icon>
          </v-list-item>
          <v-card flat to="/" class="pa-2" id="secMainNavDrawerAccessListItemCard">
            <v-list-item
              :class="logoUrl.endsWith('.svg') ? 'access-icon' : ''"
              :style="{
                backgroundImage: `url(${logoUrl})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain'
              }"
              id="secMainNavDrawerAccessListItemIcon"
            ></v-list-item>
            <p
              style="display: flex; justify-content: center"
              id="secMainNavDrawerAccessListItemText"
            >
              {{ !rail ? appName : ' ' }}
            </p>
          </v-card>
        </v-list>
        <v-divider></v-divider>
        <v-list density="compact" nav>
          <v-list-item
            v-for="(feature, index) in appState.$state.discovery?.features.filter(
              (f) =>
                f.componentName !== null && f.componentName !== '' && f.permission === 'HasAccess'
            )"
            :key="index"
            :to="feature.defaultPath"
            :prepend-icon="feature.materialDesignIconName"
            :title="feature.name"
            id="secMainNavDrawerListItem"
          >
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-layout>
  </nav>
  <v-overlay
    v-model="overlay"
    class="overlay-index"
    permanent
    @click="((rail = !rail), (overlay = !overlay))"
    id="secMainNavDrawerOverlay"
  ></v-overlay>
</template>

<style scoped>
nav {
  text-align: left;
  font-size: 1rem;
}
.chevronButtonIcon {
  position: absolute;
  bottom: calc(100% - 6.75rem);
  left: calc(100% + 1px);
}
</style>
